// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1d224ea0]{display:none}[data-v-1d224ea0] table{border-collapse:collapse}[data-v-1d224ea0] table td,[data-v-1d224ea0] table th{padding:.6em 1em;border:1px solid #dfe2e5;transition:border-color .3s ease}[data-v-1d224ea0] ul{padding-left:24px;margin-bottom:16px}[data-v-1d224ea0] a{color:#ea580c}[data-v-1d224ea0] a:hover{color:rgba(234,88,12,.8)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
